interface LocationLike {
  pathname: string;
  searchStr: string;
  hash: string;
}

export function getSafeInternalRedirect(redirect: string | undefined): string | undefined {
  if (!redirect) return undefined;
  if (!redirect.startsWith('/')) return undefined;
  if (redirect.startsWith('//')) return undefined;
  return redirect;
}

export function buildRedirectTarget(location: LocationLike): string {
  return `${location.pathname}${location.searchStr}${location.hash ? `#${location.hash}` : ''}`;
}
